import { KnowledgeBaseCategoryEnum } from '@zaoblako/shared/modules/ai/enums/knowledge-base-category.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link KnowledgeBaseCategoryEnum} enumeration values */
export const KnowledgeBaseCategoryEnumI18n: EnumI18nInterface<KnowledgeBaseCategoryEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [KnowledgeBaseCategoryEnum.DOCUMENTATION]: 'Документация',
    [KnowledgeBaseCategoryEnum.HELPDESK]: 'Заявки HelpDesk',
    [KnowledgeBaseCategoryEnum.OTHER]: 'Другое',
    [KnowledgeBaseCategoryEnum.COURSE]: 'Курс',
  },
  [I18nLocalesEnum.EN_US]: {
    [KnowledgeBaseCategoryEnum.DOCUMENTATION]: 'Documentation',
    [KnowledgeBaseCategoryEnum.HELPDESK]: 'HelpDesk task',
    [KnowledgeBaseCategoryEnum.OTHER]: 'Other',
    [KnowledgeBaseCategoryEnum.COURSE]: 'Course',
  },
};
